


import { useEffect, useState, useCallback } from "react";
import { getCashConfigurationMaster } from "../../api";

export const useBuPanLevelFeeConfiguration = (applicationDetails) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [config, setConfig] = useState(null);

  const fetchFeeConfiguration = useCallback(async () => {
    if (!applicationDetails?.academicCareerValue|| !applicationDetails?.businessAreaDispVal) return;

    try {
      setLoading(true);
      setError(null);

      const request = {
        companyCode: "AESL1",
        academicCareer: applicationDetails?.academicCareerValue,
        businessArea: ["ALL", applicationDetails?.businessAreaDispVal],
        mode: "OFFLINE",
        status: "ACTIVE",
      };

      const res = await getCashConfigurationMaster(request);

      const list = res?.data?.cashControlConfigList ?? [];
      // filtering the list based on business area if not business area then ALL will be considered
      const config=  list.find(item => item.businessArea === applicationDetails?.businessAreaDispVal)|| list.find(item => item.businessArea === "ALL")  ;
      setConfig(config);
    } catch (err) {
      console.error("Error fetching fee configuration:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [applicationDetails]);

  useEffect(() => {
    fetchFeeConfiguration();
  }, [applicationDetails]);

  return {
    loading,
    config

  };
};